import React, { useEffect, useState } from 'react';
import './Player.scss';

import { uuid } from '../../util/index';
import { style } from '../../util/image';
import URLFactory from '../../util/url';
import VideoManager from './Manager';

export const videoLayout = (source) => {
  return [
    { name: 'bigPlayButton', align: 'cc' },
    // { name: 'H5Loading', align: 'cc' },
    {
      name: 'controlBar',
      align: 'blabs',
      x: 0,
      y: 0,
      children: [
        { name: 'progress', align: 'blabs', x: 0, y: 44 },
        { name: 'playButton', align: 'tl', x: 15, y: 12 },
        { name: 'timeDisplay', align: 'tl', x: 10, y: 7 },
        { name: 'fullScreenButton', align: 'tr', x: 10, y: 12 },
        // {name:"subtitle", align:"tr",x:15, y:12},
        { name: 'setting', align: 'tr', x: 10, y: 12 },
        { name: 'volume', align: 'tr', x: 10, y: 10 }
      ]
    }
  ];
};

const getVideoSourceUrl = (source)=>{
  return source.source_detail.cut_play_url;
};

export default (props) => {
  const {
    source,
  } = props;
  const [inited, setInited] = useState(false);
  const [playerId, setPlayerId] = useState('');

  // 初始化容器
  useEffect(() => {
    if (!playerId) {
      setPlayerId(`player_${uuid()}`);
    }
  }, [!!playerId]);

  const createPlayer = () => {
    let player = new window.Aliplayer(
      {
        id: playerId,
        width: '100%',
        height: '100%',
        useH5Prism: true,
        useFlashPrism: false,
        playsinline: true,
        showBuffer: true,
        preload: false,
        autoplay: false,
        // x5_type: 'h5',
        x5_video_position: 'top',
        x5_fullscreen: true,
        // autoPlay: true,
        cover: style(source.thumb, 'wx_750_420'),
        controlBarVisibility: 'always',
        showBarTime: 5000,
        isLive: false,
        // liveRetry:5,
        source: getVideoSourceUrl(source),
        skinLayout: videoLayout(source)
      },
      function(instance) {
        VideoManager.setPlayerInstance(playerId, instance);
        setInited(true);
        // instance.getComponent('CustomDanmuSwitch').setDanmuku(danmuku);
        // playsInline={props.fullscreen ? false : true}
        // autoPlay={autoPlay || false}
        // // 这个能保证安卓上的行内播放
        // x5-playsinline="true"
        instance.tag.setAttribute('playsinline', 'true');
        instance.tag.setAttribute('x5-playsinline', 'true');
        instance.tag.style.objectFit = 'contain';
        // instance.tag.style.width = 'auto';
      }
    );
  };

  // 初始化播放器
  useEffect(() => {
    if (source && playerId) {
      createPlayer();
    }

    const resetPlayer = () => {
      let player = VideoManager.getPlayerInstance(playerId);

      if (player) {
        player.dispose();
      }

      createPlayer();
    };

    const onEventStop = ()=>{
      let player = VideoManager.getPlayerInstance(playerId);
      player.pause();
    };

    const onEventPlay = ()=>{
      let player = VideoManager.getPlayerInstance(playerId);
      player.play();
    };

    const onGetTime = (event)=>{
      let player = VideoManager.getPlayerInstance(playerId);
      let time = player.getCurrentTime();
      let evt = new Event('video-time-response-' + event.data);
      evt.data = time;
      window.dispatchEvent(evt)
    };

    window.addEventListener('custom-dispose-player', resetPlayer);
    window.addEventListener('video-play', onEventPlay);
    window.addEventListener('video-pause', onEventStop);
    window.addEventListener('video-time', onGetTime);

    return () => {
      window.removeEventListener('custom-dispose-player', resetPlayer);
      window.removeEventListener('video-play', onEventPlay);
      window.removeEventListener('video-pause', onEventStop);
      window.removeEventListener('video-time', onGetTime);
    };
  }, [!!source && !!playerId]);

  // 评论的显示逻辑
  useEffect(() => {
    if (inited) {
      const instance = VideoManager.getPlayerInstance(playerId);

      // 有两个数据来源
      // 第一个是，历史评论的内容
      // 第二个是，来自IM的消息
    }
  }, [inited]);

  let statusWait =
    source &&
    source.source_detail &&
    ['wait', 'config'].indexOf(source.source_detail.status) > -1;

  return (
    <div className="ali-video-player">
      <div className="wrapper">
        <div className="video-container" id={playerId} />
      </div>
      {statusWait ? (
        <style>{`#${playerId} .prism-big-play-btn {opacity:0;}`}</style>
      ) : null}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/VideoV2/Player.js